<template>
  <!-- 打印包裹信息   收货打印的信息-->
  <div>
    <div class="main" id="print" ref="print">
      <div class="content">
        <div class="title">包裹信息</div>

        <div class="footer">

          <div class="text">
            <img src="../../assets/img/logo2.png" alt="">
            <p>需上架：{{ datas.should_up_storage_at }}</p>
            <p>配货员：{{ datas.p_realname }}</p>
            <p>业务员：{{ datas.y_realname }}</p>
            <p>采购员：{{ datas.g_realname }}</p>
            <p>客户名：{{ datas.user_realname }}</p>
            <p>订单号：{{ datas.order_sn }}</p>
          </div>
          <div class="tiaoxingma">
            <div class="item">
              <div class="item-top">交易号：{{ datas.purchase_no }}</div>
              <!-- 一维码 -->
              <div class="item-footer">
                <canvas id="purchase_no" />
              </div>
            </div>
            <div class="item">
              <div class="item-top">物流号：{{ datas.express_no }}</div>
              <!-- 一维码 -->
              <div class="item-footer">
                <canvas id="express_no" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    datas: { type: Object },
  },
  data() {
    return {
      QRlink: "2022101711125796-1",
      QRImgUrl: "",
    };
  },
  created() {
    // this.$nextTick(() => {
    //   this.$print(this.$refs.print)
    // })
  },
  mounted() {
    this.getJsBarcode("#purchase_no", this.datas.purchase_no);
    this.getJsBarcode("#express_no", this.datas.express_no);
  },
  methods: {
    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 240,
        width: 6,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },
    // 二维码
    getQRcode(data) {
      this.$QRCode.toDataURL(
        data,
        { errorCorrectionLevel: "L", margin: 2, width: 128 },
        (err, url) => {
          if (err) throw err;
          this.QRImgUrl = url;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  height: 1772px;
  background: #fff;
  padding: 60px;
  box-sizing: border-box;
  color: #000000 !important;

  div {
    box-sizing: border-box;
  }

  .content {
    width: 1061px;
    height: 162px;

    border: 8px solid #000000;
    border-top: 0;
    position: relative;
    padding-top: 160px;

    .title {
      position: absolute;
      left: -8px;
      top: 0;
      width: 1061px;
      height: 160px;
      background: #000000;
      text-align: center;
      line-height: 160px;
      font-size: 80px;

      font-weight: 600;
      color: #ffffff;
      margin: 0;
    }

    .footer {
      width: 100%;
      height: 1492px;
      padding: 60px 60px 292px 60px;

      .text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 0;
        margin-bottom: 60px;
        position: relative;

        img {
          position: absolute;
          top: 20px;
          right: 0;
          width: 400px;
        }

        p {
          font-size: 40px;
          font-weight: 600;
          color: #000000;
          margin-bottom: 20px;
        }
      }

      .tiaoxingma {
        .item {
          width: 100%;
          height: 320px;

          &:nth-child(1) {
            margin-bottom: 120px;
          }

          .item-top {
            width: 941px;
            height: 60px;
            line-height: 60px;
            font-size: 40px;

            font-weight: 600;
            color: #000000;
            margin-bottom: 20px;
          }

          .item-footer {
            width: 100%;
            height: 240px !important;
            ;
            overflow: hidden;

            img {
              width: 941px;
              height: 240px !important;
              overflow: hidden;

            }
          }
        }
      }


    }
  }
}
</style>
